<template>
  <a-modal v-bind:open="this.showModal"
           width="800px"
           :closable="true"
           :footer="null"
           :mask-closable="false"
           :mask-style="{backdropFilter: 'blur(2px)'}"
           :keyboard="false"
           @cancel="uiHandler.closeModal"
  >
    <div style="padding: 50px 10px 20px 10px">
      <a-table class="ant-table-striped"
               bordered
               size="small"
               :columns="subscription.columns"
               :data-source="processedDataSource"
               :pagination="false"
      >
        <template #emptyText>
          <div class="noData">
            <i class="fa-solid fa-exclamation-triangle" style="font-size: 24px; margin-bottom: 10px"/><br>
            <span>조회결과가 없습니다</span>
          </div>
        </template>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
const readOnly = {
  event: {
    CloseModal: "CloseModal"
  },
}

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false
    },
    dataSource: {
      type: Array,
      required: true,
      default: () => []
    },
  },
  computed: {
    processedDataSource() {
      return this.dataSource.map((d, idx) => {
        return {...d, no: idx + 1}
      })
    }
  },
  data() {
    return {
      uiHandler: this.ui(),
      subscription: {
        columns: [
          {key: 'no', title: '회차', dataIndex: 'no', align: 'center', width: 40},
          {key: 'regularPaymentDay', title: '정기결제일', dataIndex: 'regularPaymentDay', align: 'center'},
          {
            key: 'actualPaymentDay', title: '실결제일', dataIndex: 'actualPaymentDay', align: 'center',
            customRender: ({text, record}) => {
              return (
                  text ? text : '-'
              )
            }
          },
          {
            key: 'regularPaymentAmount', title: '정기결제금액', dataIndex: 'index', align: 'center',
            customRender: ({text, record}) => {
              const regularPaymentAmount = record?.regularPaymentAmount?.toLocaleString();
              return (
                  <div style={{display: 'flex', justifyContent: 'end'}}>
                    <a-typography-text>{regularPaymentAmount}원</a-typography-text>
                  </div>
              )
            }
          },
        ]
      }
    }
  },
  methods: {
    ui() {
      return {
        closeModal: () => {
          this.$emit(readOnly.event.CloseModal, {
            ModalStatus: false
          });
        }
      }
    }
  }
}
</script>
<style scoped></style>